import { useProfile } from '@/modules/profile';
import { ModalInfoCreate } from './modal-info.elements';

export const CreateModalInfo = () => {
  const { fullName } = useProfile();

  return <ModalInfoCreate authorName={fullName} />;
};
